import { render, staticRenderFns } from "./ServiceRequestCreate.vue?vue&type=template&id=5fa46665&scoped=true"
import script from "./ServiceRequestCreate.vue?vue&type=script&lang=js"
export * from "./ServiceRequestCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa46665",
  null
  
)

export default component.exports